export const getters = {
    cities(state) {
        return state.cities
    },
    districts(state) {
        return state.districts
    },
    wards(state) {
        return state.wards
    },
}
